<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!items.length > 0">Você não possui banners ativos</h3>
            <h3 v-if="items.length > 0">
              Você possui {{ items.length }} banner{{
                items.length > 1 ? "s" : ""
              }}
              ativo{{ items.length > 1 ? "s" : "" }}
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="redirect"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar banner
            </b-button>
            <b-button
              variant="primary"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="alterarOrdem"
              :disabled="!(items.length > 1)"
            >
              <i class="fa fa-cloud fa-xl"></i>
              Salvar ordem
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="items.length > 0" class="mt-3">
      <table
        class="table table-striped table-bordered"
        style="background: white"
      >
        <thead>
          <tr>
            <th scope="col">Ordem</th>
            <th scope="col">Imagem</th>
            <th scope="col">Data Criação</th>
            <th scope="col">Local Exibição</th>
            <th scope="col">Tipo</th>
          </tr>
        </thead>
        <draggable v-model="items" tag="tbody" @update="atualizarItens">
          <tr
            v-for="item in items"
            :key="item.urlfoto"
            @click="abrirModal(item)"
          >
            <td scope="row" class="center-text">{{ item.ordem }}</td>
            <td>
              <img
                :src="item.urlthumbnail"
                alt="Foto"
                class="center-image"
                height="150px"
                width="200px"
              />
            </td>
            <td class="center-text">
              {{ item.createdAt }}
            </td>

            <td scope="row" class="center-text" v-if="item.local == 1">
              Página Principal
            </td>
            <td scope="row" class="center-text" v-else-if="item.local == 2">
              Página de Produtos
            </td>
            <td scope="row" class="center-text" v-else>Não Informado</td>

            <td class="center-text" v-if="item.bannerType == 1">Jornalzinho</td>
            <td class="center-text" v-else-if="item.bannerType == 2">
              Promoção
            </td>
            <td class="center-text" v-else-if="item.bannerType == 3">
              Sorteios
            </td>
            <td class="center-text" v-else-if="item.bannerType == 4">Cupom</td>
            <td class="center-text" v-else-if="item.bannerType == 5">Link</td>
            <td class="center-text" v-else>Comum</td>
          </tr>
        </draggable>
      </table>
    </b-card>
    <b-card v-else>
      <center>
        <div>
          <i class="fa fa-frown-o fa-custom-size"></i>
          <h4>Desculpe, não encontramos nenhum banner :(</h4>
          <h5>Para cadastrar, clique no botão acima e comece!</h5>
        </div>
      </center>
    </b-card>
    <b-modal ref="modal" centered hide-footer title="Opções">
      <b-row>
        <b-col xl="6" lg="6" md="6" sm="12">
          <div class="centerModal" @click="editar">
            <i class="fa fa-pencil-square fa-4x"></i>
            <span class="span-card">Editar</span>
          </div>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12">
          <div class="centerModal" @click="excluirBanner">
            <i class="fa fa-times fa-4x"></i>
            <span class="span-card">Excluir</span>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ImageItem from "./ImageItem";
import axios from "axios";
import * as config from "@/config.json";
import draggable from "vuedraggable";
import Loading from "vue-loading-overlay";

export default {
  components: { draggable, Loading, ImageItem },
  data: () => {
    return {
      isLoading: false,
      items: [],
      fields: [],
      idBannerSelecionado: null,
      urlBannerSelecionado: null,
      localExibicao: null,
    };
  },
  methods: {
    abrirModal(i) {
      this.idBannerSelecionado = i.id;
      this.urlBannerSelecionado = i.urlfoto;
      this.redirectBannerSelecionado = i.redirecionar;
      this.$refs.modal.show();
      localStorage.setItem("localExibicaoBanner", i.local);
      localStorage.setItem("selectedOptionID", i.bannerType);
      localStorage.setItem("selectedPromotionID", i.promotionId);
      localStorage.setItem("url_banner", this.urlBannerSelecionado);
      localStorage.setItem("redirect_banner", this.redirectBannerSelecionado);
    },

    editar() {
      localStorage.setItem("editar_banner", "true");
      localStorage.setItem("id_banner", this.idBannerSelecionado);
      this.$router.push(`/banner/editar`);
    },

    async deleteBanner(id) {
      const url = `${config.default.servidor}/gerencial/banner/${id}`;
      try {
        const response = await axios({
          url,
          method: "delete",
          headers: {
            authorization: `${config.default.authorizationBasic}`,
          },
        });

        if (response.status == 200) {
          this.$alert("O banner foi excluido!", "Sucesso", "success");
          this.getItems();
        }
      } catch (error) {
        console.log({ error });
        this.$alert("Falha ao excluir o banner!", "Erro", "error");
      }
    },

    async excluirBanner() {
      this.$refs.modal.hide();
      await this.$swal({
        title: "Banner",
        text: "Confirma excluir este banner?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (res.value) {
          this.deleteBanner(this.idBannerSelecionado);
        }
      });
    },

    redirect() {
      this.$router.push(`/banner/adicionar`);
    },

    async alterarOrdem() {
      var arrayTratado = [];
      for (let i = 0; i < this.items.length; i++) {
        const e = this.items[i];
        arrayTratado.push({
          id: e.id,
          ordem: i + 1,
        });
      }

      const url = `${config.default.servidor}/gerencial/banner/ord`;
      try {
        const response = await axios({
          url,
          method: "post",
          data: {
            array: arrayTratado,
          },
          headers: {
            authorization: `${config.default.authorizationBasic}`,
          },
        });

        if (response.status == 200) {
          this.$alert("Ordem alterada!", "Sucesso", "success");

          setTimeout(() => {
            this.getItems();
          }, 100);
        }
      } catch (error) {
        this.$alert("Falha ao alterar a ordem!", "Erro", "error");
      }
    },

    async getItems() {
      localStorage.removeItem("editar_banner");
      localStorage.removeItem("url_banner");
      localStorage.removeItem("redirect_banner");
      localStorage.removeItem("id_banner");
      localStorage.removeItem("localExibicaoBanner");
      localStorage.removeItem("selectedOptionID");
      localStorage.removeItem("selectedPromotionID");

      const url = `${
        config.default.servidor
      }/gerencial/banner/${localStorage.getItem("enterprise_id")}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: {
            authorization: `${config.default.authorizationBasic}`,
          },
        });
        if (response.status == 200) {
          this.items = response.data.data;
        }
      } catch (error) {
        this.$alert("Falha ao buscar banner!", "Erro", "error");
      }
    },

    async atualizarItens() {
      for (let i = 0; i < this.items.length; i++) {
        const e = this.items[i];
        e.ordem = i + 1;
      }
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getItems();
    await this.atualizarItens();
    this.isLoading = false;
  },
};
</script>